import SVGInline from 'react-svg-inline';

import { PropertyExplorerCharts as chartTheme } from 'legacy/css-modules';

import chevronRight from 'legacy/assets/svg-inline/chevron_right_HCBlue.svg';

const ChartButton = ({ children, title }) => {
  return (
    <div className={chartTheme.ChartButton} data-hc-name="chart-button">
      <div
        className={chartTheme.ChartButtonHeader}
        data-hc-name="chart-button-title"
      >
        {title}
      </div>
      <div
        className={chartTheme.ChevronContainer}
        data-hc-name="chart-button-icon"
      >
        <SVGInline height="40px" width="40px" svg={chevronRight} />
      </div>
      {children}
    </div>
  );
};

export default ChartButton;
